import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { applyCoupon } from "../services/couponService";
import { Box, Button, TextField, Typography, Paper, Alert } from "@mui/material";

const CouponApplicator = () => {
	const { user } = useAuth();
	const [couponCode, setCouponCode] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!couponCode || !phoneNumber) {
			setMessage("Please enter both coupon code and phone number");
			return;
		}

		setLoading(true);
		setMessage("");

		try {
			await applyCoupon(couponCode, phoneNumber);
			setMessage("Coupon applied successfully!");
			setCouponCode("");
			setPhoneNumber("");
		} catch (error) {
			setMessage(`Error: ${error.message}`);
		} finally {
			setLoading(false);
		}
	};

	if (!user) {
		return (
			<Typography variant="h6" color="error">
				Please sign in to apply coupons
			</Typography>
		);
	}

	return (
		<Paper sx={{ p: 3, mt: 2 }}>
			<Typography variant="h5" gutterBottom>
				Apply Coupon
			</Typography>
			{message && (
				<Alert severity={message.includes("Error") ? "error" : "success"} sx={{ mb: 2 }}>
					{message}
				</Alert>
			)}
			<form onSubmit={handleSubmit}>
				<Box sx={{ mb: 2 }}>
					<TextField fullWidth label="Enter Coupon Code" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} required />
				</Box>
				<Box sx={{ mb: 2 }}>
					<TextField fullWidth label="Phone Number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} required />
				</Box>
				<Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
					{loading ? "Applying..." : "Apply Coupon"}
				</Button>
			</form>
		</Paper>
	);
};

export default CouponApplicator;
